/* eslint-disable */
import { Button } from '@getgrover/ui';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import ggAddress, { AddressComponent_Item as AddressListItem } from 'ggApp/modules/address';
import ggStore from 'ggApp/modules/store';
import ggPayment, {
    PaymentComponent_List as PaymentMethodsList,
} from 'ggApp/modules/payment';
import ggAuth from 'ggApp/modules/auth';
import {
    LayoutComponent_Checkout_Add as CheckoutAddPaymentMethodButton,
} from 'ggApp/modules/layout';
import ggOrder from 'ggApp/modules/order';
import ggRouter, {
    RouterComponent_LinkWithStore as Link,
} from 'ggApp/modules/router';
import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';
import ggAdyen from 'ggApp/modules/adyen';
import OrderVoucherConnect from 'ggApp/shared/containers/order/voucher';

import PaymentScreenWrapper from './ScreenWrap';
import { Summary } from './styles';

@connect(
    createStructuredSelector({
        adyenSavedPaymentData: ggAdyen.selectors.savedPaymentData,
        user: ggAuth.selectors.user,
        order: ggOrder.selectors.orderActive,
        addressList: ggAddress.selectors.addressList,
        addressActiveShippingId: ggAddress.selectors.activeAddressShippingId,
        addressActiveBillingId: ggAddress.selectors.activeAddressBillingId,
        addressActiveBilling: ggAddress.selectors.activeAddressBilling,
        paymentMethodListByUser: ggPayment.selectors.listUserPaymentMethods,
        paymentActiveMethodIdByUser: ggPayment.selectors.activeUserPaymentMethodId,
        store: ggStore.selectors.storeActive,
    }),
    (dispatch) => ({
        routerActions: bindActionCreators(ggRouter.actions, dispatch),
        orderActions: bindActionCreators(ggOrder.actions, dispatch),
    }),
)
export default class ListPaymentScreen extends Component {
    componentWillMount() {
        const { routerActions } = this.props;
        const { order, user } = this.props;

        if (order.shipping_address_id === null || !user.phone_verified) {
            routerActions.transitionTo('/checkout/address');
        }
    }

    render() {
        const { orderActions } = this.props;
        const {
            paymentMethodListByUser,
            store,
            paymentActiveMethodIdByUser,
            addressActiveShippingId,
            addressActiveBillingId,
            addressActiveBilling,
            addressList,
            order,
        } = this.props;
        const billingAddressCondition = addressActiveShippingId === addressActiveBillingId
            || addressActiveBillingId === null
            || !addressActiveBilling;
        const noPaymentMethods = paymentMethodListByUser.length === 0;
        const modalAddressSuccessUrl = encodeURIComponent('/checkout/payment');
        const addressAddUrl = `/checkout/payment?modal=address-create&modal-address-type=billing&modal-address-success-url=${modalAddressSuccessUrl}`;
        const modalAddressAddUrl = encodeURIComponent(addressAddUrl);

        return (
            <PaymentScreenWrapper>
                <PaymentMethodsList
                    updateOrderPaymentMethod={(
                        paymentId,
                        paymentType,
                    ) => {
                        orderActions.updateOrder({
                            current_payment_source_id: paymentId,
                            current_payment_source_type: paymentType,
                        });
                        orderActions.updateOrderPaymentMethod(
                            order.number,
                            paymentId,
                            paymentType,
                        );
                    }}
                    activeId={paymentActiveMethodIdByUser}
                    list={paymentMethodListByUser}
                />

                {!noPaymentMethods && (
                    <CheckoutAddPaymentMethodButton
                        text="DONT_HAVE_PAYMENT"
                        linkText="ADD_NEW_PAYMENT"
                        to="/checkout/payment?modal=payment-create"
                    />
                )}
                {!billingAddressCondition && (
                    <AddressListItem
                        noEdit
                        title="BILLING_ADDRESS"
                        active
                        onClick={() => {}}
                        address={addressActiveBilling}
                    />
                )}
                <CheckoutAddPaymentMethodButton
                    text={
                        billingAddressCondition
                        && 'SAME_ADDRESSES'
                    }
                    linkText="ADD_NEW_ADDRESS"
                    to={
                        addressList.length > 1
                            ? `/checkout/payment?modal=address-select&modal-address-type=billing&modal-address-add-url=${modalAddressAddUrl}`
                            : addressAddUrl
                    }
                />

                <OrderVoucherConnect order={order} />
                <Summary
                    order={{
                        currencySymbol: order.currencySymbol,
                        subtotal: order.item_total,
                        shipping: order.shipment_total,
                        voucherDiscount: order.voucher && order.voucher.discount,
                        total: order.total,
                    }}
                />
                <Link to="/checkout/summary">
                    <Button
                        primary
                        fullWidth
                        centred
                        disabled={
                            paymentActiveMethodIdByUser
                            === null
                        }
                    >
                        <Translator tk="CONTINUE" />
                    </Button>
                </Link>
            </PaymentScreenWrapper>
        );
    }
}
